// BehaviorSectionSkeleton.js
import React from 'react';
import { Box, Skeleton, Stack, Divider } from '@mui/material';

const BehaviorSectionSkeleton = () => {
  return (
    <Box sx={{ p: 3, mb: 4 }}>
      <Skeleton variant="text" width="30%" height={40} />
      
      <Stack direction="row" alignItems="center" spacing={1} mb={2} mt={3}>
        <Skeleton variant="circular" width={24} height={24} />
        <Skeleton variant="text" width="30%" height={24} />
      </Stack>
      
      <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1 }}>
        {[...Array(3)].map((_, index) => (
          <Skeleton key={index} variant="rounded" width={100} height={32} />
        ))}
      </Stack>
      
      <Divider sx={{ my: 3 }} />
      
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <Skeleton variant="circular" width={24} height={24} />
        <Skeleton variant="text" width="30%" height={24} />
      </Stack>
      
      <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1 }}>
        {[...Array(2)].map((_, index) => (
          <Skeleton key={index} variant="rounded" width={120} height={32} />
        ))}
      </Stack>
    </Box>
  );
};

export default BehaviorSectionSkeleton;